import { keepPreviousData } from '@tanstack/react-query';
import { AGGREGATE_NAMES, LOAN_REQUEST_RESOLVERS } from 'cpool-constants';
import { schemaLoanRequestResolver_GetApplicantNotes } from 'cpool-tables/backend-resolvers';

import { useAggregateQuery } from '~/queryUtils/useQuery';
import { useChangeTypeStore } from '~/store/queryChangeTypeStore';
import { useQueryPositionStore } from '~/store/queryPositionStore';
import { queryKeys } from '~/utils/queryKeys';

const useApplicantNotes = (applicantIds: Array<string>, id: string) => {
    const changeType = useChangeTypeStore((state) => state.changeType);
    const queryKey = queryKeys.getApplicantNotes(applicantIds, id, changeType);
    const queryPosition = useQueryPositionStore((state) => state.positions[JSON.stringify(queryKey)]);
    return useAggregateQuery({
        acl: { loanRequestId: id },
        aggregateName: AGGREGATE_NAMES.LOAN_REQUEST,
        resolverName: LOAN_REQUEST_RESOLVERS.getApplicantNotes,
        schema: schemaLoanRequestResolver_GetApplicantNotes,
        searchParams: { applicantIds, changeType, id, position: queryPosition },
        tanstack: {
            placeholderData: keepPreviousData,
        },
    });
};

export default useApplicantNotes;
